export default {
	aboutThisRoom: 'About this room',
	address: 'Address',
	allEvents: 'All events',
	allNews: 'All news items',
	allPackages: 'ALL PACKAGES',
	archive: 'Archive',
	bookNow: 'Book now',
	bookThisPackage: 'Book this package',
	bookThisRoom: 'Book this room',
	buttonCall: 'Call',
	buttonReturnToOverview: 'Back to overview',
	buttonMakeReservation: 'Make a reservation',
	buttonMenu: 'Menu',
	buttonRequestInfo: 'Request information',
	checkAvailability: 'Check availability',
	checkIn: 'Check-in',
	checkOut: 'Check-out',
	contact: 'Contact',
	contactClientEmailContent: '',
	contactFormHeader: 'Send us a message',
	contactUserEmailContent: 'Thank you for filling in the form. We will get in touch with you shortly.',
	contactUserEmailContentOutro: 'You have entered the following information:',
	dateFormatMonthYear: '%B %Y',
	dateFormatShort: '%d-%m-%Y',
	de: 'Deutsch',
	emailFormContactClientSubject: 'Request form filled in',
	emailFormContactUserSubject: 'Thank you for your request',
	emailFormMeetingClientSubject: 'Request form filled in',
	emailFormMeetingUserSubject: 'Thank you for your inquiry',
	en: 'English',
	es: 'Español',
	exploreOurHotel: 'Explore our hotel',
	facilities: 'Facilities',
	faqDifferentQuestion: 'I have a different question',
	footerNavigate: 'Navigate',
	formArrival: 'Arrival',
	formBlock: 'Block',
	formCarre: 'Carre',
	formCompanyName: 'Company Name',
	formConsent: 'Yes, I agree to receive communications. Please provide consent by checking the box.',
	formDeparture: 'Departure',
	formDinner: 'Dinner',
	formEmail: 'Email address',
	formEventDate: 'Event date',
	formEventDateToBeDetermined: 'Date to be determined',
	formEventType: 'Event type',
	formGeneralErrorCaptcha: 'reCAPTCHA invalid',
	formGeneralErrorAkismet: `This e-mail address or IP has been reported for spam. Please send your e-mail manually.`,
	formMeeting: 'Meeting',
	formMeetingroomID: 'Preferred space',
	formMeetingroomSetup: 'Room setup',
	formMessage: 'Message',
	formName: 'Name',
	formNoPreference: 'No preference',
	formOtherSpecify: 'Other:',
	formOutdoor: 'Outdoor event',
	formPageID: 'Meeting package',
	formPax: 'Persons',
	formPhone: 'Phone number',
	formReception: 'Reception',
	formSchool: 'School',
	formSubmit: 'Send',
	formTheatre: 'Theatre',
	formTraining: 'Training',
	formUShape: 'U-shape',
	fr: 'Français',
	highlightsHeader: 'Choose a category',
	menu: 'Menu',
	moreEvents: 'More events',
	moreInformation: 'More information',
	moreNews: 'Keep on reading',
	moreReviews: 'More reviews',
	nl: 'Nederlands',
	otherPackages: 'Check out our other packages',
	packageFrom: 'From',
	perPerson: 'per person',
	quickLinks: 'Links',
	ratingOutOf10: ' out of 10',
	readMore: 'Read more',
	reviewSourceBookingcom: 'Booking.com',
	reviewSourceExpedia: 'Expedia',
	reviewSourceGoogle: 'Google',
	reviewSourceHotel: 'Hotel',
	reviewSourceTripadvisor: 'TripAdvisor',
	reviewSourceZoover: 'Zoover',
	reviews: 'Review',
	shareThisPost: 'Share this',
	showAll: 'Show all',
	siteByButton: 'Hotel Website by:',
	siteByUrl: 'https://www.becurious.com/',
	siteByLogo: 'https://www.becurious.com/images/logo-becurious-white-360w.png',
	upcomingEvents: 'Upcoming',
	viewThisEvent: 'Read more',
	viewThisPackage: 'View this package',
	viewThisRoom: 'View this room',
};
